




































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';
import { user } from '@/modules/shared/shared/store/namespaces';
import { Actions, Resources } from '@/modules/shared/shared/domain/constants/constants';
import OptionCard from '@/modules/tickets/dashboard/components/OptionCard.vue';
import RequirementOption from '@/modules/tickets/dashboard/components/RequirementOption.vue';
import BaseModal from '@/modules/shared/layouts/components/BaseModal.vue';
import IconButton from '@/modules/shared/shared/components/TooltipButton.vue';

@Component({
    components: { IconButton, BaseModal, RequirementOption, OptionCard },
})
export default class TicketCreate extends Vue {
    private step: number = 0;
    createAction: string = Actions.CREATE.name;
    pdtResourceName: string = Resources.PDT.name;
    ticketsResourceName: string = Resources.TICKETS.name;
    remoteHandsResourceName: string = Resources.REMOTE_HANDS.name;

    @Emit('closeDialog')
    closeDialog() {
        return false;
    }

    go(to: string) {
        this.$router.push({ name: to });
    }

    mounted() {
        this.step = 0;
    }

    $refs!: {
        modal: any;
    };

    openModal() {
        this.step = 0;
        this.$refs.modal.openModal();
    }
}
